import { render, staticRenderFns } from "./MainMenuCard.vue?vue&type=template&id=8fe9e4a6"
import script from "./MainMenuCard.vue?vue&type=script&lang=js"
export * from "./MainMenuCard.vue?vue&type=script&lang=js"
import style0 from "./MainMenuCard.vue?vue&type=style&index=0&id=8fe9e4a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports